import React from 'react';

const Loader = ({ fullPage = true, size = 48 }) => {
  if (fullPage) {
    return (
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        background: 'linear-gradient(135deg, rgba(244,237,228,0.95), rgba(27,58,99,0.05))',
        zIndex: 9999,
      }}>
        <div style={{
          width: '60px', height: '60px', border: '4px solid #F4EDE4',
          borderTop: '4px solid #1B3A63', borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }} />
        <p style={{ marginTop: '16px', fontFamily: "'Vollkorn', serif", color: '#1B3A63', fontSize: '1rem', fontWeight: 500 }}>
          Loading...
        </p>
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px',
    }}>
      <div style={{
        width: `${size}px`, height: `${size}px`,
        border: '3px solid #F4EDE4', borderTop: '3px solid #1B3A63',
        borderRadius: '50%', animation: 'spin 1s linear infinite',
      }} />
      <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default Loader;
